import { useSearchParams } from 'react-router-dom';

import { EventTypeEnum } from '../constants/enums';

export const useEventExploration = (eventType?: EventTypeEnum) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const onViewEventClick = (id: string) => {
    if (eventType) {
      searchParams.set('eventType', eventType);
    } else {
      searchParams.delete('eventType');
    }
    if (eventType === EventTypeEnum.AV) {
      searchParams.set('analyticalVariableId', id);
    } else {
      searchParams.set('eventId', id);
    }
    setSearchParams(searchParams);
  };

  return { onViewEventClick };
};
